import React, { Component } from 'react';
import Login from './scenes/AppPages/scenes/Login';
import AppFrame from './scenes/AppFrame';
import { Redirect, Switch, Route } from 'react-router-dom';
import Api from './services/Api';
import PropTypes from 'prop-types';
import assign from 'es6-object-assign';
import entries from 'object.entries';
import moment from 'moment';
import 'moment/locale/es';
import { LOGIN_STATE } from './services/Api/constants';
import { connect } from 'react-redux';
import './style.css';
import { Alert } from 'react-bootstrap';
import Notifier from './services/Notifier';
import Notifications from 'react-notification-system-redux';
import ResetPassword from './scenes/AppPages/scenes/ResetPassword';
import ForgotPassword from './scenes/AppPages/scenes/ForgotPassword';
import NotificationsStyle from './services/Notifier/NotificationsStyles';


moment.locale("es");


class App extends Component {

    static contextTypes = { store: PropTypes.object };

    static childContextTypes = {
        api: PropTypes.object,
        notifier: PropTypes.object,
    };

    constructor(props, context) {
        super(props);

        this.api = new Api(context.store);
        this.notifier = new Notifier(context.store);

        /** Shims **/
        if (!Object.entries)
            entries.shim();
        if (!Object.assign)
            assign.polyfill();
    }


    getChildContext() {
        return {
            api: this.api,
            notifier: this.notifier,
        };
    }

    render() {

        const path = this.props.history.location.pathname;
        if (this.props.loggedIn !== LOGIN_STATE.LOGGED_IN && path !== "/login" && path !== "/reset-password" && path !== "/forgot-password") {
            return <Redirect from={path} to="/login" />;
        }

        return (
            <div className="amcemig-app" >

                <Notifications notifications={this.props.notifications} style={NotificationsStyle} />

                <Switch>
                    <Route path="/forgot-password" component={ForgotPassword} />
                    <Route path="/reset-password" component={ResetPassword} />
                    <Route path="/login" component={Login} />
                    <Route path="/" component={AppFrame} />
                </Switch>

                {this.props.loading ?
                    <Alert className={'main-app-loading'}>
                        <i className='ti-shine fa-spin' /> Cargando...
                </Alert> : null}

            </div>
        )
    }
}

const mapStateToProps = ({ api: { loggedIn }, loading, notifications }) => {
    return { loggedIn, loading, notifications };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App/index.jsx